React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')

module.exports = class extends React.Component
  displayName: 'SettingSectionComponent'

  render: t.renderable ->
    { header, contents, onChange, canChange, changeContent, changeClasses } = @props

    t.div '.window-module.u-clearfix', ->

      t.div '.window-module-title', ->
        t.h3 '.u-inline', ->
          t.addElement header

      t.div '.setting-item', ->
        t.div '.setting-item-detail', ->
          t.addElement contents

        t.div '.setting-item-action', ->
          classes =
            'button-link': true
            'u-text-align-center': true
            disabled: !canChange
          if changeContent
            t.div className: changeClasses, onClick: onChange, ->
              t.addElement changeContent
          else
            t.b onChange, disabled: !canChange, class: t.classify(classes), ->
              t.format 'change'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/setting-section-component.coffee